module.exports = __webpack_public_path__ + "static/media/placeholder-image.a54fb893.jpg";